export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_05.5f37f17e.jpg";